import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import frTranslations from '../locales/fr.json';
import enTranslations from '../locales/en.json';

// Validate translations are loaded
if (!frTranslations || !enTranslations) {
  console.error('Failed to load translation files');
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: frTranslations || {} },
      en: { translation: enTranslations || {} }
    },
    lng: localStorage.getItem('language') || 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  })
  .catch((error) => {
    console.error('i18n initialization failed:', error);
  });

export default i18n;

